import { Component, OnInit } from '@angular/core';
import { CalendarFilterService } from '../../services/calendar-filter.service';

@Component({
  selector: 'app-calendar-filters',
  templateUrl: './calendar-filters.component.html',
  styleUrls: ['./calendar-filters.component.scss']
})
export class CalendarFiltersComponent implements OnInit {

  constructor(public filter_service: CalendarFilterService) {
  }

  ngOnInit() {
  }

}
